module.exports = __webpack_public_path__ + "static/media/1.f7f1cb88.jpg";